import React, { useState } from 'react';
import PlanCard from './PlanCard';

const PricingPlans = ({plans, selectedPlan, setSelectedPlan, activePlan, upcomingPlan, setUpcomingPlan, subscriptionInfo, setSubscriptionInfo, timezone}) => {

  return (
    <div className="tw-flex tw-items-center tw-justify-center">
      <div className="tw-w-full">
        <div className="tw-grid md:tw-grid-cols-3 tw-gap-6">
          {plans.map((plan, index) => (
            <PlanCard 
              plan={plan} 
              selectedPlan={selectedPlan} 
              setSelectedPlan={setSelectedPlan} 
              activePlan={activePlan} 
              upcomingPlan={upcomingPlan} 
              setUpcomingPlan={setUpcomingPlan}
              subscriptionInfo={subscriptionInfo}
              setSubscriptionInfo={setSubscriptionInfo}
              timezone={timezone}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default PricingPlans;